module.exports = __webpack_public_path__ + "img/head.a59c8186.png";